import { Helmet } from "react-helmet-async";
import ServicesSection from "@components/ServicesSection";
import Button from "@components/Button";
import SectionHeader from "../components/SectionHeader";

function Services() {
	return (
		<div>
			<Helmet>
				<title>
					Driving Lessons | Logbook Training | Test Prep & Licence Holders
				</title>
				<meta
					name="description"
					content="Driving lessons Canberra for logbook training, driving test prep and licence holders. Learn to drive in Canberra with structured lessons and real road practice."
				/>
				<link
					rel="canonical"
					href="https://steersmartdriving.com.au/services"
				/>
			</Helmet>

			<div className="flex flex-col gap-12 items-center py-6 md:py-12">
				<SectionHeader
					title="Driving Lesson Services in Canberra"
					subtitle="We offer driving lesson services in Canberra for learners at different stages. This includes logbook training, driving test preparation, refresher lessons and support for licence holders, with a focus on real road driving and practical skills."
					heading="h1"
				/>
				<ServicesSection isCarousel={false} />
				<Button
					buttonName="Book Now"
					buttonLink="/packages"
					buttonStyle="primary"
				/>
			</div>
		</div>
	);
}

export default Services;
